export const dictionary = {
  de: {
    "nav.services": "Leistungen",
    "nav.insurance": "Versicherung",
    "nav.process": "Ablauf",
    "nav.security": "Sicherheit",
    "nav.about": "Über uns",
    "nav.contact": "Kontakt",
    "nav.login": "Portal-Login",
    "nav.portal": "Zum Portal",

    "hero.badge": "Ausschließlich für Finanzinstitute & Banken",
    "hero.title": "Treuhänderische Zahlungsvermittlung zwischen Anlegern und Instituten",
    "hero.subtitle":
      "Aureus Notariat agiert als sicherer, neutraler Treuhänder zwischen Anlegern und Finanzinstituten, Banken und Vermögensverwaltungen. Wir werden ausschließlich von Instituten mandatiert – nicht von Privatpersonen.",
    "hero.cta.primary": "Portal-Zugang anfragen",
    "hero.cta.secondary": "Ablauf ansehen",
    "hero.stat1": "Verwahrtes Volumen",
    "hero.stat2": "Partnerinstitute",
    "hero.stat3": "Abwicklungssicherheit",
    "hero.insured": "Jede Zahlungsabwicklung vollständig versichert",
    "hero.location": "Frankfurt am Main · Bankenviertel",

    "trust.title": "Angebunden an führende Institute",

    "insurance.badge": "Versicherter Zahlungsverkehr",
    "insurance.title": "Jede Abwicklung ist vollständig versichert",
    "insurance.subtitle":
      "Sämtliche über Aureus Notariat abgewickelten Treuhandzahlungen sind über eine Vertrauensschaden- und Kautionsversicherung führender Erstversicherer abgesichert – vom Geldeingang bis zur finalen Freigabe an das Institut.",
    "insurance.coverageLabel": "Versicherungssumme je Vorgang",
    "insurance.coverageValue": "bis zu €100 Mio.",
    "insurance.1.title": "Vertrauensschadenversicherung",
    "insurance.1.desc":
      "Absicherung sämtlicher verwahrter Anlegergelder gegen Veruntreuung und Vermögensschäden während der gesamten Treuhandphase.",
    "insurance.2.title": "Segregierte & versicherte Konten",
    "insurance.2.desc":
      "Gelder liegen auf insolvenzfesten, separierten Treuhandkonten bei bonitätsstarken Partnerbanken – jederzeit versichert.",
    "insurance.3.title": "Regulierte Erstversicherer",
    "insurance.3.desc":
      "Der Versicherungsschutz wird ausschließlich von BaFin-regulierten Erstversicherern mit erstklassigem Rating getragen.",
    "insurance.4.title": "Lückenlose Deckung",
    "insurance.4.desc":
      "Jede Statusstufe – gesendet, eingegangen, freigegeben – ist ohne Deckungslücke durchgängig versichert.",
    "insurance.1.long":
      "Eine Vertrauensschadenversicherung führender Erstversicherer deckt sämtliche verwahrten Anlegergelder gegen Veruntreuung, Betrug und Vermögensschäden über die gesamte Treuhandphase ab.",
    "insurance.1.b1": "Deckung gegen Veruntreuung & Betrug",
    "insurance.1.b2": "Gilt für die gesamte Treuhandphase",
    "insurance.1.b3": "Erstklassig geratete Versicherer",
    "insurance.2.long":
      "Gelder liegen auf separierten, insolvenzfesten Treuhandkonten bei bonitätsstarken Partnerbanken und sind zu jedem Zeitpunkt durch den Versicherungsschutz abgedeckt.",
    "insurance.2.b1": "Insolvenzfeste Kontenstruktur",
    "insurance.2.b2": "Bonitätsstarke Partnerbanken",
    "insurance.2.b3": "Durchgängig versichert",
    "insurance.3.long":
      "Der gesamte Versicherungsschutz wird ausschließlich von BaFin-regulierten Erstversicherern mit erstklassigem Rating getragen – keine Rückversicherungs- oder Zweckgesellschaften.",
    "insurance.3.b1": "BaFin-regulierte Erstversicherer",
    "insurance.3.b2": "Erstklassiges Rating",
    "insurance.3.b3": "Transparente Policenstruktur",
    "insurance.4.long":
      "Der Versicherungsschutz greift lückenlos über alle Statusstufen – vom Zahlungsausgang (Gelb) über den Geldeingang (Grün) bis zur finalen Freigabe an das Institut.",
    "insurance.4.b1": "Keine Deckungslücke zwischen Stufen",
    "insurance.4.b2": "Gilt bis zur finalen Freigabe",
    "insurance.4.b3": "Versicherungssumme bis €100 Mio./Vorgang",

    "services.title": "Unsere Leistungen",
    "services.subtitle": "Notarielle Treuhand- und Zahlungsdienstleistungen für den institutionellen Zahlungsverkehr.",
    "services.1.title": "Treuhänderische Verwahrung",
    "services.1.desc":
      "Sichere Verwahrung von Anlegergeldern auf separierten Treuhandkonten bis zur verifizierten Freigabe an das Zielinstitut.",
    "services.2.title": "Zahlungsvermittlung",
    "services.2.desc":
      "Neutrale Weiterleitung von Zahlungen an Partnerbanken wie ING, Deutsche Bank und Postbank nach abgeschlossener Prüfung.",
    "services.3.title": "Identitäts- & Zweckprüfung",
    "services.3.desc":
      "Authentifizierung jedes Vorgangs über einen eindeutigen Verwendungszweck-Code sowie KYC-/AML-konforme Kontrollen.",
    "services.4.title": "Echtzeit-Statusverfolgung",
    "services.4.desc":
      "Transparente Nachverfolgung jeder Transaktion – von der Einzahlung über den Geldeingang bis zur finalen Freigabe.",
    "services.1.long":
      "Anlegergelder werden ausschließlich auf insolvenzfesten, klar separierten Treuhandkonten verwahrt. Erst nach vollständiger Verifizierung und institutioneller Freigabe erfolgt die Weiterleitung an das Zielinstitut.",
    "services.1.b1": "Segregierte Treuhandkonten je Mandat",
    "services.1.b2": "Insolvenzferne Verwahrung",
    "services.1.b3": "Freigabe erst nach Verifizierung",
    "services.2.long":
      "Als neutraler Treuhänder leiten wir geprüfte Zahlungen an Partnerbanken wie ING, Deutsche Bank und Postbank weiter. Jede Weiterleitung ist dokumentiert und revisionssicher nachvollziehbar.",
    "services.2.b1": "Anbindung an führende Institute",
    "services.2.b2": "Neutrale, dokumentierte Weiterleitung",
    "services.2.b3": "SEPA- & SWIFT-fähig",
    "services.3.long":
      "Jeder Vorgang wird über einen eindeutigen Verwendungszweck-Code authentifiziert und durch KYC-/AML-konforme Kontrollen abgesichert – für zweifelsfreie Zuordnung jeder Zahlung.",
    "services.3.b1": "Eindeutiger Verwendungszweck-Code",
    "services.3.b2": "KYC-/AML-konforme Prüfung",
    "services.3.b3": "Zweifelsfreie Zuordnung",
    "services.4.long":
      "Vom Anlegen über den Geldeingang bis zur Freigabe: Der Status jeder Transaktion ist in Echtzeit sichtbar – Gelb bei Zahlungsausgang, Grün bei Eingang, freigegeben nach Weiterleitung.",
    "services.4.b1": "Live-Statusanzeige (Gelb/Grün/Freigegeben)",
    "services.4.b2": "Zeitstempel für jeden Schritt",
    "services.4.b3": "Vollständiger Audit-Trail",

    "process.title": "So funktioniert die Abwicklung",
    "process.subtitle": "Ein transparenter, dreistufiger Treuhandprozess mit eindeutiger Statusanzeige.",
    "process.1.title": "Registrierung & Verwendungszweck-Code",
    "process.1.desc":
      "Das Institut registriert sich und legt einen Vorgang mit eindeutigem Verwendungszweck-Code an. Der Anleger nutzt diesen Code zur Zuordnung seiner Zahlung.",
    "process.2.title": "Authentifizierung & Geldeingang",
    "process.2.desc":
      "Sobald der Anleger die Zahlung sendet, steht der Vorgang auf Gelb. Nach verifiziertem Geldeingang auf dem Treuhandkonto wechselt der Status auf Grün.",
    "process.3.title": "Freigabe an das Institut",
    "process.3.desc":
      "Nach Freigabe wird das Guthaben an das Zielinstitut (z. B. ING, Deutsche Bank, Postbank) weitergeleitet – der Vorgang ist abgeschlossen.",

    "status.pending": "Ausstehend",
    "status.sent": "Zahlung gesendet",
    "status.received": "Geld eingegangen",
    "status.released": "An Bank freigegeben",
    "status.legend": "Statuslegende",

    "security.title": "Sicherheit & Compliance",
    "security.subtitle": "Regulatorische Sorgfalt auf höchstem Niveau.",
    "security.1.title": "Separierte Treuhandkonten",
    "security.1.desc": "Anlegergelder werden strikt getrennt vom Betriebsvermögen verwahrt.",
    "security.2.title": "KYC & AML",
    "security.2.desc": "Vollständige Geldwäscheprävention und Identitätsprüfung bei jedem Mandat.",
    "security.3.title": "Ende-zu-Ende-Verschlüsselung",
    "security.3.desc": "Alle Daten und Vorgänge werden verschlüsselt übertragen und gespeichert.",
    "security.4.title": "Notarielle Dokumentation",
    "security.4.desc": "Jeder Vorgang wird revisionssicher und rechtsverbindlich dokumentiert.",

    "ui.learnMore": "Mehr erfahren",
    "ui.details": "Details",
    "ui.close": "Schließen",
    "ui.included": "Enthaltene Leistungen",
    "ui.requestAccess": "Zugang anfragen",

    "faq.title": "Häufige Fragen",
    "faq.subtitle": "Antworten auf die wichtigsten Fragen von Instituten und Banken.",
    "faq.1.q": "Für wen ist Aureus Notariat bestimmt?",
    "faq.1.a":
      "Ausschließlich für Banken, Finanzinstitute, Fondsgesellschaften und Vermögensverwaltungen. Wir werden ausschließlich institutionell mandatiert und erbringen keine Leistungen für Privatpersonen.",
    "faq.2.q": "Wie ist mein Geld versichert?",
    "faq.2.a":
      "Alle verwahrten Gelder sind über eine Vertrauensschaden- und Kautionsversicherung BaFin-regulierter Erstversicherer abgesichert – mit einer Versicherungssumme von bis zu €100 Mio. je Vorgang, lückenlos über alle Statusstufen.",
    "faq.3.q": "Wie funktioniert der Verwendungszweck-Code?",
    "faq.3.a":
      "Das Institut legt je Vorgang einen eindeutigen Verwendungszweck-Code an. Der Anleger gibt diesen bei seiner Zahlung an, wodurch der Geldeingang zweifelsfrei dem richtigen Vorgang zugeordnet wird.",
    "faq.4.q": "An welche Banken erfolgt die Weiterleitung?",
    "faq.4.a":
      "Wir leiten Zahlungen an führende Partnerinstitute wie ING, Deutsche Bank, Postbank, Commerzbank und DZ BANK weiter – nach abgeschlossener Prüfung und institutioneller Freigabe.",
    "faq.5.q": "Wann wird das Guthaben freigegeben?",
    "faq.5.a":
      "Erst nach verifiziertem Geldeingang (Status Grün) und ausdrücklicher Freigabe wird das Guthaben an das Zielinstitut weitergeleitet. Der Status wechselt dann auf „An Bank freigegeben“.",

    "cta.title": "Sind Sie ein Finanzinstitut oder eine Bank?",
    "cta.subtitle":
      "Fordern Sie einen Portal-Zugang an und wickeln Sie Ihre treuhänderischen Zahlungen sicher über Aureus Notariat ab.",
    "cta.button": "Institutionellen Zugang anfragen",
    "cta.note": "Ausschließlich für Institute – keine Privatkunden.",

    "footer.tagline": "Sicherer treuhänderischer Zahlungsvermittler für Finanzinstitute.",
    "footer.rights": "Alle Rechte vorbehalten.",
    "footer.disclaimer":
      "Aureus Notariat erbringt Dienstleistungen ausschließlich für Banken, Finanzinstitute und Vermögensverwaltungen. Kein Angebot für Privatpersonen.",

    "auth.signin.title": "Portal-Anmeldung",
    "auth.signin.subtitle": "Melden Sie sich mit Ihrem institutionellen Zugang an.",
    "auth.signup.title": "Institutionellen Zugang anlegen",
    "auth.signup.subtitle": "Registrieren Sie Ihr Institut für den treuhänderischen Zahlungsverkehr.",
    "auth.email": "Geschäftliche E-Mail",
    "auth.password": "Passwort",
    "auth.name": "Name des Ansprechpartners",
    "auth.institutionName": "Name des Instituts",
    "auth.institutionType": "Art des Instituts",
    "auth.type.bank": "Bank",
    "auth.type.asset": "Vermögensverwaltung",
    "auth.type.fund": "Fondsgesellschaft",
    "auth.type.other": "Sonstiges Finanzinstitut",
    "auth.signin.button": "Anmelden",
    "auth.signup.button": "Zugang anlegen",
    "auth.toSignup": "Noch kein Zugang? Institut registrieren",
    "auth.toSignin": "Bereits registriert? Anmelden",
    "auth.wait": "Bitte warten…",
    "auth.closed.title": "Registrierung geschlossen",
    "auth.closed.desc":
      "Zugänge werden ausschließlich durch Ihr Institut vergeben. Bitte melden Sie sich mit Ihren bereitgestellten Zugangsdaten an.",
    "auth.closed.toSignin": "Zur Anmeldung",
  },
  en: {
    "nav.services": "Services",
    "nav.insurance": "Insurance",
    "nav.process": "Process",
    "nav.security": "Security",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.login": "Portal Login",
    "nav.portal": "Go to Portal",

    "hero.badge": "Exclusively for financial institutions & banks",
    "hero.title": "Fiduciary payment intermediation between investors and institutions",
    "hero.subtitle":
      "Aureus Notariat acts as a secure, neutral escrow agent between investors and financial institutions, banks and asset managers. We are engaged exclusively by institutions — never by private individuals.",
    "hero.cta.primary": "Request portal access",
    "hero.cta.secondary": "See the process",
    "hero.stat1": "Assets held in escrow",
    "hero.stat2": "Partner institutions",
    "hero.stat3": "Settlement security",
    "hero.insured": "Every payment settlement fully insured",
    "hero.location": "Frankfurt am Main · Banking district",

    "trust.title": "Connected to leading institutions",

    "insurance.badge": "Insured payment flows",
    "insurance.title": "Every settlement is fully insured",
    "insurance.subtitle":
      "All fiduciary payments settled through Aureus Notariat are covered by fidelity and surety insurance from leading primary insurers — from funds received through to final release to the institution.",
    "insurance.coverageLabel": "Insured sum per transaction",
    "insurance.coverageValue": "up to €100M",
    "insurance.1.title": "Fidelity insurance",
    "insurance.1.desc":
      "Coverage of all custodied investor funds against misappropriation and financial loss throughout the entire escrow phase.",
    "insurance.2.title": "Segregated & insured accounts",
    "insurance.2.desc":
      "Funds sit in insolvency-remote, segregated escrow accounts at high-grade partner banks — insured at all times.",
    "insurance.3.title": "Regulated primary insurers",
    "insurance.3.desc":
      "Cover is underwritten exclusively by BaFin-regulated primary insurers with top-tier credit ratings.",
    "insurance.4.title": "Gap-free coverage",
    "insurance.4.desc":
      "Every status stage — sent, received, released — is continuously insured with no coverage gap.",
    "insurance.1.long":
      "Fidelity insurance from leading primary insurers covers all custodied investor funds against misappropriation, fraud and financial loss throughout the entire escrow phase.",
    "insurance.1.b1": "Cover against misappropriation & fraud",
    "insurance.1.b2": "Applies to the entire escrow phase",
    "insurance.1.b3": "Top-tier rated insurers",
    "insurance.2.long":
      "Funds sit in segregated, insolvency-remote escrow accounts at high-grade partner banks and are covered by insurance at all times.",
    "insurance.2.b1": "Insolvency-remote account structure",
    "insurance.2.b2": "High-grade partner banks",
    "insurance.2.b3": "Insured throughout",
    "insurance.3.long":
      "The entire cover is underwritten exclusively by BaFin-regulated primary insurers with top-tier ratings — no reinsurance or special-purpose vehicles.",
    "insurance.3.b1": "BaFin-regulated primary insurers",
    "insurance.3.b2": "Top-tier rating",
    "insurance.3.b3": "Transparent policy structure",
    "insurance.4.long":
      "Cover applies seamlessly across all status stages — from payment sent (yellow) through funds received (green) to final release to the institution.",
    "insurance.4.b1": "No coverage gap between stages",
    "insurance.4.b2": "Applies through to final release",
    "insurance.4.b3": "Insured sum up to €100M / transaction",

    "services.title": "Our services",
    "services.subtitle": "Notarial escrow and payment services for institutional payment flows.",
    "services.1.title": "Fiduciary custody",
    "services.1.desc":
      "Secure custody of investor funds in segregated escrow accounts until verified release to the target institution.",
    "services.2.title": "Payment intermediation",
    "services.2.desc":
      "Neutral forwarding of payments to partner banks such as ING, Deutsche Bank and Postbank after completed verification.",
    "services.3.title": "Identity & purpose verification",
    "services.3.desc":
      "Authentication of every transaction via a unique purpose code alongside KYC/AML-compliant controls.",
    "services.4.title": "Real-time status tracking",
    "services.4.desc":
      "Transparent tracking of each transaction — from deposit through funds received to final release.",
    "services.1.long":
      "Investor funds are held exclusively in insolvency-remote, clearly segregated escrow accounts. Forwarding to the target institution occurs only after full verification and institutional release.",
    "services.1.b1": "Segregated escrow accounts per mandate",
    "services.1.b2": "Insolvency-remote custody",
    "services.1.b3": "Release only after verification",
    "services.2.long":
      "As a neutral escrow agent we forward verified payments to partner banks such as ING, Deutsche Bank and Postbank. Every transfer is documented and audit-proof.",
    "services.2.b1": "Connected to leading institutions",
    "services.2.b2": "Neutral, documented forwarding",
    "services.2.b3": "SEPA & SWIFT capable",
    "services.3.long":
      "Every transaction is authenticated via a unique purpose code and secured by KYC/AML-compliant controls — for unambiguous allocation of each payment.",
    "services.3.b1": "Unique purpose code",
    "services.3.b2": "KYC/AML-compliant checks",
    "services.3.b3": "Unambiguous allocation",
    "services.4.long":
      "From creation through funds received to release: the status of each transaction is visible in real time — yellow when sent, green when received, released after forwarding.",
    "services.4.b1": "Live status (yellow/green/released)",
    "services.4.b2": "Timestamp for every step",
    "services.4.b3": "Complete audit trail",

    "process.title": "How settlement works",
    "process.subtitle": "A transparent, three-stage escrow process with clear status indication.",
    "process.1.title": "Registration & purpose code",
    "process.1.desc":
      "The institution registers and creates a transaction with a unique purpose code. The investor uses this code to reference their payment.",
    "process.2.title": "Authentication & funds received",
    "process.2.desc":
      "Once the investor sends the payment, the transaction turns yellow. After verified receipt in the escrow account the status turns green.",
    "process.3.title": "Release to the institution",
    "process.3.desc":
      "After release the funds are forwarded to the target institution (e.g. ING, Deutsche Bank, Postbank) — the transaction is complete.",

    "status.pending": "Pending",
    "status.sent": "Payment sent",
    "status.received": "Funds received",
    "status.released": "Released to bank",
    "status.legend": "Status legend",

    "security.title": "Security & compliance",
    "security.subtitle": "Regulatory diligence at the highest level.",
    "security.1.title": "Segregated escrow accounts",
    "security.1.desc": "Investor funds are held strictly separate from operating assets.",
    "security.2.title": "KYC & AML",
    "security.2.desc": "Full anti-money-laundering and identity verification on every mandate.",
    "security.3.title": "End-to-end encryption",
    "security.3.desc": "All data and transactions are transmitted and stored encrypted.",
    "security.4.title": "Notarial documentation",
    "security.4.desc": "Every transaction is documented in an audit-proof, legally binding manner.",

    "ui.learnMore": "Learn more",
    "ui.details": "Details",
    "ui.close": "Close",
    "ui.included": "What's included",
    "ui.requestAccess": "Request access",

    "faq.title": "Frequently asked questions",
    "faq.subtitle": "Answers to the most important questions from institutions and banks.",
    "faq.1.q": "Who is Aureus Notariat for?",
    "faq.1.a":
      "Exclusively for banks, financial institutions, fund companies and asset managers. We are engaged only on an institutional basis and provide no services to private individuals.",
    "faq.2.q": "How are my funds insured?",
    "faq.2.a":
      "All custodied funds are covered by fidelity and surety insurance from BaFin-regulated primary insurers — with an insured sum of up to €100M per transaction, seamlessly across all status stages.",
    "faq.3.q": "How does the purpose code work?",
    "faq.3.a":
      "The institution creates a unique purpose code per transaction. The investor references it with their payment, so incoming funds are allocated unambiguously to the correct transaction.",
    "faq.4.q": "Which banks do you forward to?",
    "faq.4.a":
      "We forward payments to leading partner institutions such as ING, Deutsche Bank, Postbank, Commerzbank and DZ BANK — after completed verification and institutional release.",
    "faq.5.q": "When are funds released?",
    "faq.5.a":
      "Only after verified receipt (green status) and explicit release are funds forwarded to the target institution. The status then changes to “Released to bank”.",

    "cta.title": "Are you a financial institution or bank?",
    "cta.subtitle":
      "Request portal access and settle your fiduciary payments securely through Aureus Notariat.",
    "cta.button": "Request institutional access",
    "cta.note": "Institutions only — no private clients.",

    "footer.tagline": "Secure fiduciary payment intermediary for financial institutions.",
    "footer.rights": "All rights reserved.",
    "footer.disclaimer":
      "Aureus Notariat provides services exclusively to banks, financial institutions and asset managers. Not an offer to private individuals.",

    "auth.signin.title": "Portal sign-in",
    "auth.signin.subtitle": "Sign in with your institutional access.",
    "auth.signup.title": "Create institutional access",
    "auth.signup.subtitle": "Register your institution for fiduciary payment settlement.",
    "auth.email": "Business email",
    "auth.password": "Password",
    "auth.name": "Contact person name",
    "auth.institutionName": "Institution name",
    "auth.institutionType": "Institution type",
    "auth.type.bank": "Bank",
    "auth.type.asset": "Asset manager",
    "auth.type.fund": "Fund company",
    "auth.type.other": "Other financial institution",
    "auth.signin.button": "Sign in",
    "auth.signup.button": "Create access",
    "auth.toSignup": "No access yet? Register institution",
    "auth.toSignin": "Already registered? Sign in",
    "auth.wait": "Please wait…",
    "auth.closed.title": "Registration closed",
    "auth.closed.desc":
      "Access is granted exclusively by your institution. Please sign in with the credentials provided to you.",
    "auth.closed.toSignin": "Go to sign in",
  },
};
